import { IGameAttendancesVotes } from '@grassrootly/api';
import { useGameView } from '../../../api/game/GameViewSelector';

export interface IGameVotesHook {
  votes: IGameAttendancesVotes[];
  votesCount: number;
  playerVoted: (playerId: number) => boolean
};

export function useGameVotes({ gameId }: { gameId: number }): IGameVotesHook {
  // Get game data from the optimized view instead of making separate API calls
  const gameView = useGameView(gameId);

  const playerVoted = (playerId: number): boolean => {
    if (!gameView?.attendees) return false;
    
    // Use the player_voted field from the attendance view
    const attendee = gameView.attendees.find(a => a.player_id === playerId);
    return attendee?.player_voted || false;
  };

  return {
    votes: [], // Legacy field - no longer needed since we have player_voted in attendance view
    votesCount: gameView?.players_voted_count || 0,
    playerVoted
  };
}
